import { MODAL_STATUS_TOGGLE } from '../action/actionTypes'

const initialState = {
    showToggle: false,
    Platform: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case MODAL_STATUS_TOGGLE:
            return {
                ...state,
                showToggle: !state.showToggle,
                Platform : action.Platform,
            }

        default:
            return state;
    }
};

export default reducer;